export default __webpack_public_path__ + "static/media/objectives.eeeb4614.svg";